import { render, staticRenderFns } from "./TabCabecalho.vue?vue&type=template&id=4f847548&scoped=true"
import script from "./TabCabecalho.vue?vue&type=script&lang=js"
export * from "./TabCabecalho.vue?vue&type=script&lang=js"
import style0 from "./TabCabecalho.vue?vue&type=style&index=0&id=4f847548&prod&lang=css"
import style1 from "./TabCabecalho.vue?vue&type=style&index=1&id=4f847548&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f847548",
  null
  
)

export default component.exports